export enum UrlRegexIndexes {
  ASSET_REGEX = 'assetRegex',
  COMPENSATE_REGEX = 'compensateRegex'
}

export const URL_REGEXES: UrlRegexs = {
  [UrlRegexIndexes.ASSET_REGEX]: /^(https:|http:)?\/\/assets/,
  [UrlRegexIndexes.COMPENSATE_REGEX]: /^https?:\/\/(www\.)?compensate\.com/
};

interface UrlRegexs {
  [key: string]: RegExp;
}
